var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13C1 14.1081 1.89206 15 2.99998 15H13C14.1081 15 15 14.1079 15 13V2.99998C15 1.89194 14.1079 1 13 1H2.99998C1.89194 1 1 1.89194 1 2.99998V7.01041L9.66135 7.30211C8.93742 6.57817 8.21348 5.85424 7.4894 5.13016C7.90119 4.82314 8.34506 4.49087 8.70289 4.2187C9.92325 5.57043 11.0471 6.79811 12.1092 7.99997C10.8824 9.34762 9.79691 10.6052 8.70289 11.7812C8.2583 11.4434 7.91732 11.189 7.4894 10.8698C8.21333 10.1458 8.93727 9.42191 9.66135 8.69783L1 8.98952V13Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/Return.dc8b6d839ad3fdfa99c176d7646e54cf.svg";
export { ForwardRef as ReactComponent };